import * as React from 'react';
import autobind from 'autobind-decorator';

import { SupplierGeneralPartView } from './suppliergeneral-part.view';
import { CardController } from 'src/app/shared/card.controller';
import { CurrencyListDataService } from 'src/app/general/currencies/list/currency-list.data';

interface SupplierGeneralPartControllerProps extends ComponentViewProps<SupplierItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	onLogoChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;

}

export class SupplierGeneralPartController extends React.Component<SupplierGeneralPartControllerProps, any> {
	protected currencyDataService: CurrencyListDataService;

	constructor(props) {
		super(props);
		this.currencyDataService = CurrencyListDataService.make();
	}

	@autobind
	private currencyQuery(q?: string) {
		return new Promise<QueryResult<CurrencySummary>>((resolve, reject) => {
			this.currencyDataService.addSorting('iso3Name', 'asc', true)
			this.currencyDataService.searchKeywords = q;
			return this.currencyDataService
				.load(query => query)
				.then((res) => {
					this.props.setBusy(false);
					resolve({
						items: res,
						totalCount: this.currencyDataService.count
					});
				})
				.catch((error) => {
					this.props.setBusy(false);
					reject(error);
				});
		});
	}

	render() {
		const supplier = this.props.model;
		if (supplier == null) {
			return null;
		}

		return (
			<CardController
				icon="book"
				className="card-borderless"
				title="General Information"
				mode={this.props.mode}>
				<SupplierGeneralPartView
					mode={this.props.mode}
					onLogoChange={this.props.onLogoChange}
					model={supplier}
					setBusy={this.props.setBusy}
					onModeChanged={this.props.onModeChanged}
					currencies={{ query: this.currencyQuery, dataSet: this.currencyDataService }}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/form/parts/suppliergeneral-part.controller.tsx